import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { bulkPredictSurfaceTreatment } from "#modules/quoteRequestLines/infra/bulkPredictSurfaceTreatment.api";

import { quoteRequestLineQuery } from "../infra/quoteRequestLine.query";

export const useBulkPredictSurfaceTreatment = (options?: {
  onSuccess?: (resultsByTreatment: Record<string, string[]>) => void;
  onError?: (err: Error) => void;
  onMutate?: () => void;
}) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: bulkPredictSurfaceTreatment,
    onMutate: () => {
      options?.onMutate?.();
    },
    onSuccess: (resultsByTreatment) => {
      const allUpdatedIds = Object.values(resultsByTreatment).flat();
      allUpdatedIds.forEach((id) => {
        void queryClient.invalidateQueries(quoteRequestLineQuery({ id }));
      });
      options?.onSuccess?.(resultsByTreatment);
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
      options?.onError?.(err);
    },
  });

  return { bulkPredictSurfaceTreatment: mutate, ...rest };
};
